/*
 * @Author: chenjianxiong 2232943862@qq.com
 * @Date: 2025-05-08 15:04:03
 * @LastEditors: chenjianxiong 2232943862@qq.com
 * @LastEditTime: 2025-12-26 17:44:06
 * @FilePath: \easyrent_front\src\util\auth.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import CryptoJS from 'crypto-js'
const key = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_ECB_AUTH_CODE) // 十六位十六进制数作为密钥
// const iv = CryptoJS.enc.Utf8.parse('ABCDEF1234123412') // 十六位十六进制数作为密钥偏移量
const authUtils = {
  getBaseURL() {
    // return "https://www.abroadpass.com/web"
    return "http://nero.free.idcfengye.com"
  },
  getToken() {
    const indexData = localStorage.getItem("common")
    const d = JSON.parse(JSON.parse(JSON.stringify(indexData)))
    if (d && d.isLogin) {
      return d.user.access_token
    } else {
      return ''

    }
  },


  // 解密方法
  decrypt(word: string) {
    const decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  },

  // 加密方法
  encrypt(word: string) {
    const srcs = CryptoJS.enc.Utf8.parse(word)
    const encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    return encrypted.toString()
  }
}
export { authUtils }
